'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
require('@material-ui/core/ButtonBase');
require('@material-ui/icons/ArrowBack');
require('@material-ui/core');
var renderCell = require('./utils/renderCell.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var TotalCell = _ref => {
  var {
    type,
    label,
    value,
    column
  } = _ref;
  var {
    width = 0,
    align = 'left'
  } = column;
  return /*#__PURE__*/React__namespace.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: clsx_m("GenjoDataTable__cell", "GenjoDataTable__total-cell"),
    style: {
      width: width,
      maxWidth: width,
      minWidth: width,
      textAlign: align
    }
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: "GenjoDataTable__total-label"
  }, label), /*#__PURE__*/React__namespace.createElement("span", null, renderCell.renderCell(type, value)));
};
TotalCell.propTypes = {};

exports.TotalCell = TotalCell;
